import React, { useEffect } from 'react';
import Select from 'react-select';

const options = [
  { value: 'RA', label: 'Rajasthan' },
  { value: 'UP', label: 'Uttar Pradesh' },
  { value: 'SI', label: 'Sikkim' },
  { value: 'AA', label: 'Andaman & Nicobar Island'}
];

export default function StateInput(props) {
  const handleChange = (newState) => {
    props.handleChange(newState.value, undefined, undefined)
  }
  // useEffect(() => {
  //   props.handleChange(options[0].value, undefined, undefined);
  // }, [])
  return (
    <div >
      <h1> State</h1>
      <Select
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}